module.exports = __webpack_public_path__ + "img/38.71962428.jpg";